import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../../utils/apiClient';

// Initialize state from localStorage
const getInitialState = () => {
    let user = null;
    let token = null;

    try {
        const storedUser = localStorage.getItem('authUser');
        const storedToken = localStorage.getItem('authToken');

        if (storedUser) {
            user = JSON.parse(storedUser);
        }
        if (storedToken) {
            token = storedToken;
            apiClient.setAuthToken(storedToken);
        }
    } catch (error) {
        console.error('Error parsing stored auth data:', error);
    }

    return {
        user,
        token,
        isAuthenticated: !!token,
        isInitialized: true,
    };
};

const authSlice = createSlice({
    name: 'auth',
    initialState: getInitialState(),
    reducers: {
        login: (state, action) => {
            const { user, token } = action.payload;
            state.user = user;
            state.token = token;
            state.isAuthenticated = true;

            // Sync with localStorage
            try {
                localStorage.setItem('authUser', JSON.stringify(user));
                localStorage.setItem('authToken', token);
            } catch (error) {
                console.error('Error saving auth data to localStorage:', error);
            }

            // Sync with apiClient
            apiClient.setAuthToken(token);
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;

            // Clear localStorage
            try {
                localStorage.removeItem('authUser');
                localStorage.removeItem('authToken');
            } catch (error) {
                console.error('Error clearing auth data from localStorage:', error);
            }

            // Clear apiClient token
            apiClient.removeAuthToken();
        },
        updateUser: (state, action) => {
            state.user = action.payload;

            // Sync with localStorage
            try {
                if (action.payload) {
                    localStorage.setItem('authUser', JSON.stringify(action.payload));
                } else {
                    localStorage.removeItem('authUser');
                }
            } catch (error) {
                console.error('Error saving user data to localStorage:', error);
            }
        },
        setInitialized: (state, action) => {
            state.isInitialized = action.payload;
        },
    },
});

export const { login, logout, updateUser, setInitialized } = authSlice.actions;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectIsInitialized = (state) => state.auth.isInitialized;

// Role-based selectors
export const selectIsOwner = (state) => state.auth.user?.role === 'owner';
export const selectIsManager = (state) => state.auth.user?.role === 'manager';
export const selectIsStaff = (state) => state.auth.user?.role === 'staff';
export const selectIsChef = (state) => state.auth.user?.role === 'chef';
export const selectAssociatedRestaurant = (state) => state.auth.user?.associatedRestaurant;
export const selectCanAccessRestaurants = (state) => state.auth.user?.role === 'owner';
export const selectCanAccessAllRestaurants = (state) => state.auth.user?.role === 'owner';

export default authSlice.reducer;

